"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PictureFrame = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const styled_components_1 = tslib_1.__importDefault(require("../Themes/styled-components"));
const Wrapper = styled_components_1.default('div') `
  position: relative;
  width: 100%;
  padding-top: ${({ scWidth, scHeight }) => 100 / (scWidth / scHeight)}%;
`;
const Content = styled_components_1.default.div `
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
`;
class PictureFrame extends React.PureComponent {
    render() {
        const { className, width, height, children } = this.props;
        return (React.createElement(Wrapper, { className: className, scWidth: width, scHeight: height },
            React.createElement(Content, null, children)));
    }
}
exports.PictureFrame = PictureFrame;
exports.default = PictureFrame;
